import { nextArrow, prevArrow, options } from "@/global/slick-options";

const sliders = document.querySelectorAll( '[data-slider="accreditations-slider"' );

sliders.forEach( slider => {
    if ( slider.dataset.sliderLayout == 'rows' ) {
        const arrowsWrap = slider.closest( '.accreditations' )?.querySelector( '.accreditation-arrows' );
        jQuery( slider ).slick( {
            ...options,
            slidesToShow: 1,
            infinite: true,
            rows: 0,
            centerMode: true,
            centerPadding: '0',
            focusOnSelect: false,
            variableWidth: true,
            autoplay: true,
            appendArrows: arrowsWrap,
        } );

    } else if ( slider.dataset.sliderLayout == 'columns' ) {
        jQuery( slider ).slick( {
            ...options,
            infinite: true,
            slidesToShow: 3,
            rows: 3,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: true,
            pauseOnFocus: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        rows: 1,
                        centerMode: true,
                    }
                },
            ]
        } );
    }
} );
